import {createEntitySlice} from 'utils/createEntitySlice';
import {Service} from 'types/service';
import {ServicesThunks} from 'features/programs/program/services/servicesThunks';

export interface ServiceState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  services?: any;
  pagy?: any;
  service?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: ServiceState = {
  status: 'idle',
  error: null,
  services: [],
  service: {name: ''},
  pagy: {},
  isEditing: false,
  activeTab: '',
};

const servicesSlice = createEntitySlice<Service>({
  name: 'service',
  initialState,
  thunks: ServicesThunks,
  entityKey: 'service',
  entitiesKey: 'services',
  reducers: {},
});

export const {
  setEntity: setService,
  setIsEditing,
  setActiveTab,
} = servicesSlice.actions;
export {initialState as serviceInitialState};
export default servicesSlice.reducer;
